export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center w-full overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20crimson%20and%20amber%20tones%2C%20soft%20organic%20shapes%2C%20modern%20minimal%20design%2C%20clean%20editorial%20composition%2C%20subtle%20texture%2C%20no%20text%2C%20no%20people%2C%20artistic%20abstract%20wallpaper%20with%20smooth%20color%20transitions%20in%20red%20and%20gold%20hues%2C%20warm%20energy%20vibe%2C%20professional%20quality%2C%20high%20resolution&width=1600&height=900&seq=hero-bg-2026-x1&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-500/90 text-background-50 text-sm font-label font-bold tracking-wide mb-6">
              🔥 每日更新 · 全网最热
            </span>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading text-background-50 leading-tight mb-4">
              51吃瓜黑料
              <span className="block text-accent-300 mt-2 text-xl sm:text-2xl md:text-3xl lg:text-4xl font-body font-bold">
                全网黑料爆料视频一站式观看平台
              </span>
            </h1>

            <p className="text-lg md:text-xl text-background-300 font-label font-medium mb-4">
              吃瓜不迷路，黑料不错过
            </p>

            <p className="text-sm md:text-base text-background-200/90 max-w-[600px] mx-auto lg:mx-0 leading-relaxed mb-8">
              51吃瓜黑料是专注娱乐八卦与黑料爆料的在线视频聚合平台，覆盖明星网红、社会热点、圈内秘闻等多维度内容。
              每日精选全网最新吃瓜视频与黑料视频，集话题追踪、热门排行、深度专题于一体，让你不错过任何一个瓜。
              当前站内正在热追多条重磅爆料线索，社区讨论持续升温。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-accent-300">2000+</div>
                <div className="text-xs md:text-sm text-background-300 mt-1">每日更新视频</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-accent-300">50万+</div>
                <div className="text-xs md:text-sm text-background-300 mt-1">活跃吃瓜群众</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-accent-300">24h</div>
                <div className="text-xs md:text-sm text-background-300 mt-1">全天候实时追踪</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-label font-bold text-base hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
              >
                <i className="ri-play-circle-fill text-lg"></i>
                立即吃瓜
              </a>
              <a
                href="#topics"
                className="px-8 py-3.5 rounded-full border-2 border-background-300/60 text-background-50 font-label font-bold text-base hover:bg-background-50/10 transition-all duration-200 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
              >
                <i className="ri-fire-line text-lg"></i>
                查看热门话题
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/5] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20dramatic%20editorial%20visual%20for%20entertainment%20news%20platform%2C%20warm%20crimson%20and%20amber%20gradient%20background%2C%20abstract%20geometric%20overlay%20with%20play%20button%20motif%2C%20modern%20minimalist%20design%2C%20bold%20color%20contrast%2C%20news%20media%20aesthetic%2C%20clean%20composition%2C%20cinematic%20lighting%2C%20no%20text%2C%20no%20people%2C%20professional%20editorial%20graphic%20design&width=960&height=1200&seq=hero-visual-2026-x2&orientation=portrait"
                alt="51吃瓜黑料主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}